import PropTypes from 'prop-types'
import './FormTitleRow.scss'
import FormTitleChip from "./FormTitleChip.jsx"


export default function FormTitleRow({text, chip, className, ...props}) {
  return (
    <h4 className={`form-title text-left ${className ? className : ''}`} {...props}>
      {chip &&
        <div className="chip-wrapper">
          <FormTitleChip chip={chip} />
        </div>
      } {text}
    </h4>
  )
}

FormTitleRow.propTypes = {
  chip: PropTypes.any,
  className: PropTypes.string,
  text: PropTypes.string.isRequired
}